import { SearchItem } from '../../../../models/search-item';
import { Aggregate } from '../../../../models/aggregate';
import {
  addDraftFilterFailedAction,
  addDraftFilterStartedAction,
  addDraftFilterSucceededAction,
  removeAllDraftFiltersSucceededAction,
  removeDraftFilterFailedAction,
  removeDraftFiltersAndKeepLastAggSucceededAction,
  removeDraftFilterStartedAction,
  removeDraftFilterSucceededAction,
  updateDraftFilterFailedAction,
  updateDraftFilterStartedAction,
  updateDraftFilterSucceededAction
} from '../action/draft-filter.action';
import { createReducer, on } from '@ngrx/store';


export interface DraftFilterDatas {
  filterItems: SearchItem[];
  lastAgg: Aggregate;
}

export interface DraftFilterState {
  datas: DraftFilterDatas;
  loading: boolean;
  error: any;

}

export const DRAFT_FILTER_ITEMS_INITIAL_STATE: DraftFilterState = {
  datas: {
    filterItems: [],
    lastAgg: null
  },
  loading: false,
  error: null
};

/*
export const draftFilterReducerOld = (state: DraftFilterState = DRAFT_FILTER_ITEMS_INITIAL_STATE, action: PayloadAction<DraftFilterDatas>) => {
  switch (action.type) {
    case DraftFilterActionConstant.ADD_FILTER_ITEMS_START:
    case DraftFilterActionConstant.REMOVE_FILTER_ITEM_STARTED:
    case DraftFilterActionConstant.UPDATE_FILTER_ITEMS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DraftFilterActionConstant.ADD_FILTER_ITEMS_SUCCEEDED:
      const add = state.datas;
      if (!action.payload.filterItems[0].operator) {
        add.filterItems = add.filterItems.concat(action.payload.filterItems[0]);
      } else {
        const existingFilterItemRange = add.filterItems.find(existingFilterItem => existingFilterItem.operator === action.payload.filterItems[0].operator && existingFilterItem.path === action.payload.filterItems[0].path);
        if (!existingFilterItemRange) {
          add.filterItems = add.filterItems.concat(action.payload.filterItems[0]);
        } else {
          add.filterItems[add.filterItems.indexOf(existingFilterItemRange)] = action.payload.filterItems[0];
        }
      }
      add.lastAgg = action.payload.lastAgg;
      return {
        ...state,
        datas: add,
        loading: false,
        error: null,
      };
    case DraftFilterActionConstant.UPDATE_FILTER_ITEMS_SUCCEEDED:
      const toReplace: SearchItem = action.payload.filterItems[0];
      let found = false;
      let searchItems = state.datas.filterItems.map(aFilterItem => {
        if (aFilterItem.path === toReplace.path && aFilterItem.operator === toReplace.operator) {
          found = true;
          return toReplace;
        } else {
          return aFilterItem;
        }
      });
      if (!found) {
        searchItems = [...searchItems, toReplace];
      }
      return {
        ...state,
        datas: {
          ...state.datas,
          filterItems: searchItems,
          lastAgg: action.payload.lastAgg
        },
        loading: false,
        error: null,
      };
    case DraftFilterActionConstant.ADD_FILTER_ITEMS_FAILED:
    case DraftFilterActionConstant.REMOVE_FILTER_ITEM_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case DraftFilterActionConstant.REMOVE_ALL_FILTER_ITEMS_SUCCEEDED:
      return {
        ...state,
        datas: {
          filterItems: [],
          lastAgg: null
        },
        loading: false,
        error: null,
      };
    case DraftFilterActionConstant.REMOVE_FILTERS_AND_KEEP_LAST_AGG_SUCCEEDED:
      return {
        ...state,
        datas: {
          ...state.datas,
          filterItems: []
        },
        loading: false,
        error: null,
      };
    case DraftFilterActionConstant.REMOVE_FILTER_ITEM_SUCCEEDED:
      const filterItem: SearchItem = action.payload.filterItems[0];
      let oldLastAgg = state.datas.lastAgg;
      let remove: SearchItem[];
      if (!filterItem.operator) {
        remove = state.datas.filterItems.filter(item => item.path !== filterItem.path || item.value !== filterItem.value);
      } else {
        remove = state.datas.filterItems.filter(item => item.path !== filterItem.path || item.operator !== item.operator);
      }
      if (remove.length === 0) {
        oldLastAgg = null;
      }
      return {
        ...state,
        datas: {
          filterItems: remove,
          lastAgg: oldLastAgg
        },
        loading: false,
        error: null,
      };
  }
  return state;
};
*/

export const draftFilterReducer = createReducer(
  // Initial State
  DRAFT_FILTER_ITEMS_INITIAL_STATE,

  // Start Action
  on(addDraftFilterStartedAction, updateDraftFilterStartedAction, removeDraftFilterStartedAction, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // Add Succeeded Action
  on(addDraftFilterSucceededAction, (state, { payload }) => ({
    ...state,
    datas: {
      filterItems: state.datas.filterItems.concat(payload.filterItems[0]),
      lastAgg: payload.lastAgg
    },
    loading: false,
    error: null,
  })),

  // Update Succeeded Action
  on(updateDraftFilterSucceededAction, (state, { payload }) => {
    const toReplace: SearchItem = payload.filterItems[0];
    let found = false;
    let searchItems = state.datas.filterItems.map(aFilterItem => {
      if (aFilterItem.path === toReplace.path && aFilterItem.operator === toReplace.operator) {
        found = true;
        return toReplace;
      } else {
        return aFilterItem;
      }
    });
    if (!found) {
      searchItems = [...searchItems, toReplace];
    }
    return {
      ...state,
      datas: {
        filterItems: searchItems,
        lastAgg: payload.lastAgg
      },
      loading: false,
      error: null,
    };
  }),

  // Remove Succeeded Action
  on(removeDraftFilterSucceededAction, (state, { payload }) => {
    const filterItem: SearchItem = payload.filterItems[0];
    let oldLastAgg = state.datas.lastAgg;
    let remove: SearchItem[];
    if (!filterItem.operator) {
      remove = state.datas.filterItems.filter(item => item.path !== filterItem.path || item.value !== filterItem.value);
    } else {
      remove = state.datas.filterItems.filter(item => item.path !== filterItem.path || item.operator !== item.operator);
    }
    if (remove.length === 0) {
      oldLastAgg = null;
    }
    return {
      ...state,
      datas: {
        filterItems: remove,
        lastAgg: oldLastAgg
      },
      loading: false,
      error: null,
    };
  }),

  // Remove All Succeeded Action
  on(removeAllDraftFiltersSucceededAction, (state) => ({
    ...state,
    datas: {
      filterItems: [],
      lastAgg: null
    },
    loading: false,
    error: null,
  })),

  // Remove and Keep Last Agg Succeeded Action
  on(removeDraftFiltersAndKeepLastAggSucceededAction, (state) => ({
    ...state,
    datas: {
      ...state.datas,
      filterItems: []
    },
    loading: false,
    error: null,
  })),

  // Failed Actions
  on(addDraftFilterFailedAction, updateDraftFilterFailedAction, removeDraftFilterFailedAction, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
